export default "__VITE_ASSET__CxwF8R6A__"